import { authenticatedFetch, getApiBaseUrl } from '../functions/apiCalls/api';

let pendingReset;

// Mensagens locais de OCR devem manter o retorno da etapa que abriu a leitura.
export function getLatestButtonLink(messages) {
    const message = [...messages].reverse().find(m =>
        m?.origin === 'bot' && !m?.typing && m?.response !== 'Digitando...' &&
        typeof m?.buttonLink === 'boolean'
    );
    return {
        buttonLink: message?.buttonLink === true,
        buttonLinkText: message?.buttonLink === true ? message.buttonLinkText || '' : ''
    };
}

/**
 * Reinicia o atendimento retornando ao menu inicial.
 * Se o chat estiver montado na página/iframe, utiliza o reinício em memória via
 * window.chatRestartToInitialMenu(), evitando recarregamento de página completo (window.location.reload),
 * o que previne que webviews dentro de apps mobile interceptem a navegação e abram navegadores externos.
 */
export function handleResetToHome() {
    try {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('restart_chat_initial_menu', 'true');
        }
    } catch (e) {
        console.error('Erro ao acessar sessionStorage:', e);
    }

    const restart = () => {
        if (typeof window !== 'undefined' && typeof window.chatRestartToInitialMenu === 'function') {
            try {
                window.chatRestartToInitialMenu();
                return;
            } catch (e) {
                console.error('Erro ao executar chatRestartToInitialMenu:', e);
            }
        }

        // Notify the embedding parent when the in-memory handler is unavailable.
        try {
            if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
                window.parent.postMessage({ __chat_event: true, type: 'restart' }, '*');
            }
        } catch (e) { }

        // Preserve the reload fallback if no in-memory handler is registered.
        try {
            if (typeof window !== 'undefined' && window.location && typeof window.location.reload === 'function') {
                window.location.reload();
            }
        } catch (e) {
            console.error('Erro ao recarregar a tela:', e);
        }
    };

    const conversationId = typeof window !== 'undefined' && window.currentConversationId;
    if (!conversationId) {
        restart();
        return;
    }

    if (pendingReset?.conversationId === conversationId) {
        return;
    }
    const reset = { conversationId };
    pendingReset = reset;
    const completeReset = () => {
        if (pendingReset !== reset) {
            return;
        }
        pendingReset = undefined;
        if (window.currentConversationId === conversationId) {
            restart();
        }
    };

    const params = new URLSearchParams(window.location.search);
    const clientId = window.currentClientId || params.get('client_id') || 'web-default';
    const brand = params.get('marca') || 'fleury';
    const origin = params.get('origem') || 'web';
    let timeoutId;
    const deadline = new Promise(resolve => {
        timeoutId = setTimeout(resolve, 1500);
    });
    let notification;
    try {
        notification = authenticatedFetch(`${getApiBaseUrl()}/conversation/provider-menu-reset`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ conversation_id: conversationId, client_id: clientId, marca: brand, origem: origin })
        });
    } catch (error) {
        clearTimeout(timeoutId);
        console.error('Failed to notify provider of menu reset:', error);
        completeReset();
        return;
    }
    Promise.race([notification, deadline]).catch(error => {
        console.error('Failed to notify provider of menu reset:', error);
    }).finally(() => {
        clearTimeout(timeoutId);
        completeReset();
    });
}
